// extracted by mini-css-extract-plugin
export default {"root":"styles_root__5Tc+e","icon":"styles_icon__e1YSb","tooltip":"styles_tooltip__QjhlK"};